module.exports = __webpack_public_path__ + "img/bilo.9dbd649b.png";